import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import { push } from 'connected-react-router';

import Logo from './logo.png';
import { authenticate } from '../../redux/actions/authentications';
import ErrorMsgField from '../../components/ErrorMsgField';
import schema from '../../form-validation/auth';
import { isAuthenticated } from '../../auth';

function Login () {
  const { register, handleSubmit, errors, reset } = useForm({
    validationSchema: schema,
    reValidateMode: 'onSubmit'
  });
  const authentications = useSelector(state => state.authentications);
  const dispatch = useDispatch();
  const submitButton = useRef();
  const [data, setData] = useState({ username: '', password: '' });

  const submit = () => {
    dispatch(authenticate(data, reset, submitButton.current));
  };

  const handleChange = evt => {
    evt.preventDefault();
    const { name, value } = evt.target;
    setData({ ...data, [name]: value });
  };

  useEffect(() => {
    if (isAuthenticated()) {
      dispatch(push('/dashboard'));
    }
  }, [dispatch]);

  return (
    <div className="page-content page-membership">
      <div className="member-container">
        <div className="app-logo">
          <img src={Logo} width="208" height="67" alt="4Case Solutions" />
        </div>
        <div className="member-container-inside">
          {!authentications.authLoginSuccess &&
            !authentications.authLoginError && (
            <div className="alert alert-info text-center" role="alert">
                Identifique-se
            </div>
          )}
          {authentications.authLoginError &&
            authentications.errorContent &&
            authentications.errorContent.response &&
            authentications.errorContent.response.status === 403 && (
            <div className="alert alert-danger text-center" role="alert">
                Licenciamento excedido
            </div>
          )}
          {authentications.authLoginError &&
            authentications.errorContent &&
            (!authentications.errorContent.response ||
              (authentications.errorContent.response &&
                authentications.errorContent.response.status !== 403)) && (
            <div className="alert alert-danger text-center" role="alert">
                Falha na autenticação
            </div>
          )}
          <form onSubmit={handleSubmit(submit)}>
            <div className="form-group mb-1">
              <input
                type="text"
                id="username"
                name="username"
                className="form-control"
                placeholder="Nome de usuário"
                autoComplete="off"
                onChange={handleChange}
                ref={register}
              />
              {errors.username && errors.username.type === 'required' ? (
                <ErrorMsgField type="required" />
              ) : (
                <small className="form-text m-0">&nbsp;</small>
              )}
            </div>
            <div className="form-group mb-1 mt-0">
              <input
                type="password"
                id="password"
                name="password"
                className="form-control"
                placeholder="Senha"
                autoComplete="off"
                onChange={handleChange}
                ref={register}
              />
              {errors.password && errors.password.type === 'min' && (
                <ErrorMsgField type="min" msg="Senha muito curta" />
              )}
              {errors.password && errors.password.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
              {!errors.password && (
                <small className="form-text m-0">&nbsp;</small>
              )}
            </div>
            <div className="form-group mt-0">
              <button
                type="submit"
                className="btn btn-success btn-block"
                ref={submitButton}
              >
                Autenticar
              </button>
            </div>
          </form>
        </div>
        <p>
          <small className="copy-right">
            Copyright &copy;{`${new Date().getFullYear()} `}
            <a
              href="https://www.4case.com.br/"
              target="_blank"
              rel="noopener noreferrer"
            >
              4Case Solutions
            </a>
          </small>
        </p>
      </div>
    </div>
  );
}

export default Login;
